/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReferralLedgerEntryTypeEnum {
    Pending = 'pending',
    Earned = 'earned',
    Used = 'used',
    Canceled = 'canceled'
}

export function ReferralLedgerEntryTypeEnumFromJSON(json: any): ReferralLedgerEntryTypeEnum {
    return ReferralLedgerEntryTypeEnumFromJSONTyped(json, false);
}

export function ReferralLedgerEntryTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLedgerEntryTypeEnum {
    return json as ReferralLedgerEntryTypeEnum;
}

export function ReferralLedgerEntryTypeEnumToJSON(value?: ReferralLedgerEntryTypeEnum | null): any {
    return value as any;
}

